import { useState } from "react";
import { useMutation, useQueryClient } from "react-query";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../hooks/hooks";
import { useGetTeacherEvaluationCriteriasQuery } from "../../hooks/useGetTeacherEvaluationCriteriasQuery";
import { TeacherEvaluationCriteriaType } from "../../types/TeacherEvaluation";
import { updateTeacherEvaluationCriteria } from "../../services/school/teacher/teacherEvaluationCriteria";
import { Key_teacherEvaluationCriterias } from "../../utils/constants";
import toast from "react-hot-toast";
import { routes } from "../../routes";
import { setTeacherEvaluationCriteriaData } from "../../redux/slices/school/teacherEvaluationCriteria";
import { Pencil1Icon, TrashIcon } from "@radix-ui/react-icons";
import { ConfirmAlertDialog } from "../../components/common/ConfirmAlertDialog";
import { Lists } from "../../components/common/Lists";
import TableComponent from "../../components/common/Tables";


const columnNamesMap: { [key: string]: string } = {
    description: 'Critério de avaliação',
    academicYear: 'Ano lectivo',

};
export const TeacherEvaluationCriterias = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const queryClient = useQueryClient();
    const { data, status } = useGetTeacherEvaluationCriteriasQuery({ PageNumber: currentPage, PageSize: 400 });
    const [deleteItem, setDeleteItem] = useState<TeacherEvaluationCriteriaType | null>(null);
    const mutationUpdate = useMutation(updateTeacherEvaluationCriteria, {
        onSuccess: () => {
            queryClient.invalidateQueries(Key_teacherEvaluationCriterias);
            toast.success('Critério de avaliação eliminado');
        },
        onError: () => {
            toast.error("Erro ao eliminar o critério de avaliação.")
        }
    });
    const handlePageChange = (page: number) => {
        setCurrentPage(page);
    };
    const handleClickCreate = (event: any): void => {
        navigate(routes.createTeacherEvaluationCriteria)
    }
    const handleEdit = (c: TeacherEvaluationCriteriaType) => {
        dispatch(setTeacherEvaluationCriteriaData(c));
        navigate(routes.updateTeacherEvaluationCriteria)
    };
    const handleDelete = (c: TeacherEvaluationCriteriaType) => {
        c.status = false;
        mutationUpdate.mutateAsync(c)
    };

    const openDeleteDialog = (s: TeacherEvaluationCriteriaType) => {
        setDeleteItem(s);
    };  
    const confirmDelete = async () => {
        if (deleteItem) {
            await handleDelete(deleteItem!)
        }
    };
    const options = data?.items.map((c: TeacherEvaluationCriteriaType) => [
        {
            label: 'Editar',
            onClick: () => handleEdit(c),
            icon: <Pencil1Icon />
        },
        {
            label: 'Excluir',
            onClick: () => openDeleteDialog(c),
            icon: <TrashIcon />
        }
    ]) || [];


   return (
        <>
            <Lists
                status={status}
                TableComponent={() =>
                    <TableComponent
                        columns={Object.keys(columnNamesMap)}
                        items={data?.items}
                        options={options}
                        columnNamesMap={columnNamesMap}
                        totalPages={data?.totalPages || 1}
                        currentPage={currentPage}
                        onPageChange={handlePageChange}
                        emptyMessage="Ainda não existem critérios de avaliação registados."
                    />
                }
                handleClickCreate={handleClickCreate}
            />
            <ConfirmAlertDialog
                open={!!deleteItem}
                onOpenChange={(open) => !open && setDeleteItem(null)}
                title="Esta operação é irreversível"
                description={`Pretende eliminar o critério de avaliação "${deleteItem?.description ?? ''}"?`}
                confirmLabel="Eliminar"
                item={deleteItem}
                onConfirm={confirmDelete}
                onCancel={() => setDeleteItem(null)}
            />
        </>
    );
}
